import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
const StyledHeaderCell = styled(TableHeaderCell) `
    color: ${props => props.theme.primary.base};
    font-weight: 700;
    font-size: 18px;
`;
const ClaimTableHeader = ({ title }) => {
    return (_jsx(TableHeader, { children: _jsx(StyledHeaderCell, { children: title }) }));
};
export default ClaimTableHeader;
